import { Link } from "react-router-dom";

interface MangaCardProps {
  slug: string;
  title: string;
  coverUrl: string;
  status: string;
  rating: number;
  category: string;
  views?: number;
  chapters?: number;
}

export default function MangaCard({ slug, title, coverUrl, status, rating, category, views, chapters }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${slug}`}
      className="group block"
      data-product-shop
    >
      <div className="relative aspect-[5/7] overflow-hidden rounded-lg bg-background-200 mb-2.5">
        <img
          src={coverUrl}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          title={`${title} - 迷妹漫画`}
        />
        <div className="absolute top-2 left-2">
          <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${status === "已完结" ? "bg-accent-500 text-background-50" : "bg-primary-500 text-background-50"}`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent pt-6 pb-2 px-2">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            <span className="text-[11px] text-background-50">{rating}</span>
            {views !== undefined && (
              <span className="text-[10px] text-background-50/60 ml-auto">{views > 10000 ? `${(views / 10000).toFixed(0)}万阅` : `${views}阅`}</span>
            )}
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-1">
        {title}
      </h3>
      <div className="flex items-center gap-1.5 mt-1">
        {chapters !== undefined && (
          <span className="text-[11px] text-foreground-500">共{chapters}话</span>
        )}
        {category && (
          <>
            {chapters !== undefined && <span className="text-[11px] text-foreground-400">·</span>}
            <span className="text-[11px] text-foreground-500">{category}</span>
          </>
        )}
      </div>
    </Link>
  );
}